export const SMALL = 'SMALL';
export const LARGE = 'LARGE';
